import { SupportTicket } from './SupportTicket';

export interface SupportCategory {
  id: number;
  name: string;
  tickets: SupportTicket[];
}

export const exampleSupportCategory: SupportCategory = {
  id: 1,
  name: 'Help',
  tickets: [],
};
